<template>
  <ProgressSpinner
    :strokeWidth="strokeWidth"
    :fill="fill"
    :animationDuration="animationDuration"
    :size="size"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ProgressSpinner from 'primevue/progressspinner'
import type { ONEProgressSpinnerProps } from './types'

export default defineComponent({
  name: 'ONEProgressSpinner',
  components: {
    ProgressSpinner
  },
  inheritAttrs: false
})
</script>

<script setup lang="ts">
withDefaults(defineProps<ONEProgressSpinnerProps>(), {
  strokeWidth: '2',
  size: '100',
  fill: 'none',
  animationDuration: '2s'
})
</script>
